import $ from "jquery";
import "zebra_datepicker";

import moment from "moment";
import { Klass, u_, csl } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";
import "./klass.VuwTextField";


/**
 * VuwDateField (extends VuwTextField)
 * @options
 * - {Boolean} required
 * - {VuwDateField instance} pairField (for PC)
 */
vuwer.appendKlass("VuwDateField", {
	inpType: "date",
	inpClassList: ["inp", "inp-date"],
	_html5Input: Klass("Console").device[0] === "sp",
	
	_initialize: function _initialize(opt) {
		if(!moment) {
			throw new Error("moment.js isn't included.");
		}
		
		if( Klass("VuwDateField").parent._initialize.call(this, opt) ) {
			// inpType: period 用
			this.idStr = this.idStr.replace(/\[(\w*)\]/, "_$1").replace(/_$/, "");
			return this;
		} else {
			return false;
		}
	},
	
	getInpReady: function getInpReady($self) {
		Klass("VuwDateField").parent.getInpReady.call(this, $self);
		if(this.$inp.length && !this._html5Input) {
			// **** attachPlugin ****	for PC
			this.initDatePicker();
		}
		return this;
	},
	
	setVal: function setVal(value, antiTriggerChange) {
		u_.isString(value) || (value = "");
		if(value) {
			value = moment(value);
			if( value.isValid() ) {
				value = value.format("YYYY-MM-DD");
			} else {
				value = "";
			}
		}
		
		Klass("VuwField").prototype.setVal.call(this, value);
		
		if(this.$inp.length && !antiTriggerChange) {
			this.$inp.val(value).trigger("change", [true]);
		}
		return this;
	},
	
	_renderField: function _renderField() {
		var attr = {
			type: this._html5Input ? "date" : "text",
			name: this.paramKey,
			id: ["inp", this.idStr].join("_")
		};
		
		return $("<fieldset/>").addClass("vuw-field field-date").attr({
			"id": ["field", this.idStr].join("_"),
			"data-name": this.paramKey
		}).append(
			$("<input/>").addClass( this.inpClassList.join(" ") ).attr(attr)
		);
	},
	
	initDatePicker: function initDatePicker() {
		if(Klass("Console").browser[0] === "ie" && Klass("Console").browser[1] <= 8 && $.fn.mask) {
			this.$inp.mask("0000-00-00");
		} else
		if($.fn.Zebra_DatePicker) {
			// [Zebra_DatePicker]
			this.$inp.Zebra_DatePicker({
				format: "Y-m-d",
				days: moment.weekdaysShort(),
				months: moment.monthsShort(),
				header_captions: {
					"days": "Y年F",
					"months": "Y年",
					"years": "Y1 - Y2年"
				},
				first_day_of_week: 0,
				select_other_months: false,
				default_position: "below",
				offset: [8, -88],
				show_icon: false,						//アイコン非表示
				show_clear_date: true,			//クリアボタン表示
				lang_clear_date: "クリア",
				show_select_today: false,		//「今日」ボタン非表示
				onSelect: function onSelect(value) {
					var vuwField = $.data(this.get(0), "vuwField");
					if( value && vuwField && vuwField.pairField && !vuwField.pairField.getVal() ) {
						// 連動する日付フィールドが存在し、データが空であれば日付ピッカーの表示を更新する
						vuwField.pairField.zDatePicker.update({
							start_date: value
						});
					}
					
					this.trigger("change", [false, "datePicker"]);
				},
				onClear: function onClear() {
					this.data("Zebra_DatePicker").settings.onSelect.call(this, "");
				}
			});
			
			this.zDatePicker = this.$inp.data("Zebra_DatePicker");
		} else {
			csl.warn(this.getAddress() + " ... Zebra_DatePicker plugin isn't included.");
		}
	}
}, "VuwTextField");
